import { useState } from "react";
import { motion } from "framer-motion";
import { CLIENTS } from "@/lib/clients";

const GridLogo = ({ client }) => {
  const [failed, setFailed] = useState(false);
  const src = client.logo || `https://logo.clearbit.com/${client.domain}?size=256`;

  return (
    <motion.div
      data-testid={`client-grid-${client.name.toLowerCase().replace(/[^a-z]/g, "")}`}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="group relative flex h-40 md:h-52 items-center justify-center border-b border-r border-border bg-card p-6"
    >
      {failed ? (
        <span className="font-bebas text-4xl md:text-5xl text-foreground/60">
          {client.name}
        </span>
      ) : (
        <img
          src={src}
          alt={`${client.name} logo`}
          onError={() => setFailed(true)}
          loading="lazy"
          className="max-h-24 md:max-h-32 w-auto object-contain grayscale opacity-60 group-hover:opacity-100 group-hover:grayscale-0 transition-all duration-500"
        />
      )}
      <div className="absolute bottom-0 left-0 h-[3px] w-0 bg-primary group-hover:w-full transition-all duration-500" />
    </motion.div>
  );
};

export const ClientGrid = () => {
  return (
    <section
      id="clients"
      data-testid="clients-grid-section"
      className="bg-background px-6 md:px-12 lg:px-16 py-24 md:py-32"
    >
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
        <div>
          <span className="font-mono text-xs uppercase tracking-widest text-primary">
            [ 03 — Our Clients ]
          </span>
          <h2 className="font-bebas uppercase leading-[0.85] text-foreground text-6xl md:text-8xl mt-4">
            Trusted Across
            <br />
            India By
          </h2>
        </div>
        <p className="font-plex text-muted-foreground max-w-sm">
          Chosen by the country&apos;s leading power, steel and infrastructure
          enterprises for mission-critical scaffolding.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 border-t border-l border-border">
        {CLIENTS.map((c) => (
          <GridLogo key={c.name} client={c} />
        ))}
      </div>
    </section>
  );
};
